import { directoryActiveViewResource, directoryFavoriteViewsResource } from '@townsquare/directory-header/resources';
import Loadable from '@townsquare/loadable';
import {
  goalDirectoryArchivedRoute,
  goalDirectoryFollowingRoute,
  goalDirectoryRoute,
  goalNoWorkspaceDirectoryRoute,
} from '@townsquare/routes/goal-directory-view';
import { titanEapCrossFlowQueryResource } from '@townsquare/titan-eap-cross-flow/resource';
import { tqlExplainerResource } from '@townsquare/tql/resource';

import { goalDirectoryResource } from './resources/goal-directory';
import { goalDirectoryTableResource } from './resources/goal-directory-table';

// Goal Directory View
const GoalDirectoryLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "goalDirectory-view" */ './components/GoalDirectory'),
  loading: () => null,
});

goalDirectoryRoute.component = GoalDirectoryLoadable;
goalDirectoryRoute.resources = [
  goalDirectoryResource,
  goalDirectoryTableResource,
  tqlExplainerResource,
  directoryActiveViewResource,
  directoryFavoriteViewsResource,
];
export const goalDirectoryRouterRoute = goalDirectoryRoute;

// No Workspace Goal Directory View
const GoalsNoWorkspaceDirectoryLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "GoalsNoWorkspaceDirectory" */ './components/EmptyOrNonProvisionedState'),
  loading: () => null,
});

goalNoWorkspaceDirectoryRoute.component = GoalsNoWorkspaceDirectoryLoadable;
goalNoWorkspaceDirectoryRoute.resources = [titanEapCrossFlowQueryResource];
export const goalNoWorkspaceDirectoryRouterRoute = goalNoWorkspaceDirectoryRoute;

// Following Goals Directory View
const FollowingGoalsDirectoryLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "FollowingGoalsDirectory" */ './components/GoalDirectory'),
  loading: () => null,
});

goalDirectoryFollowingRoute.component = FollowingGoalsDirectoryLoadable;
goalDirectoryFollowingRoute.resources = [
  goalDirectoryResource,
  goalDirectoryTableResource,
  tqlExplainerResource,
  directoryActiveViewResource,
];
export const goalDirectoryFollowingRouterRoute = goalDirectoryFollowingRoute;

// Archived Goals Directory View
const ArchivedGoalsDirectoryLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "ArchivedGoalsDirectory" */ './components/GoalDirectory'),
  loading: () => null,
});

goalDirectoryArchivedRoute.component = ArchivedGoalsDirectoryLoadable;
goalDirectoryArchivedRoute.resources = [
  goalDirectoryResource,
  goalDirectoryTableResource,
  tqlExplainerResource,
  directoryActiveViewResource,
  directoryFavoriteViewsResource,
];
export const goalDirectoryArchivedRouterRoute = goalDirectoryArchivedRoute;
